import React from 'react';
import { TicketsContainer } from './ui';

export const TicketsScreen: React.FC = () => <TicketsContainer />;
